/*eslint-disable */
import {
  getproductsapi,
  getjurisdictionapi,
  getsinglestatapi,
  gettotalviews,
  gettopjursapi,
  saveuserchartsapi,
  getuserchartsapi,
} from './networklogic.js';
import SelectPure from './SelectPure-Mod.js'

var usercharts = [];
var userId;
var jurisdictions, times, products;

//Key = id (int) value = Design name (string)
var designmap = new Map();
var jurmap = new Map();

//After Abhijeet's mod to the dropdown, when you load a new dropdown the onchange gets called and can mess stuff up with updatingstats
var allowstats2update = false;
var stopall = false;

let Chartobject = class {
    constructor(columns, rows, title, xtitle, div, chartid, jurdropdownclass, productdropdownclass, timedropdownclass, charttypeid, graphcardid) {
        //Names of the Columns in the google charts
        this.columns = columns;
        //Names of the rows in the google charts
        this.rows = rows;
        //Name of the Title in the google charts
        this.title = title;
        //Name of the X axis in the google charts
        this.xtitle = xtitle;
        //unused, use chartid for now
        this.div = div;
        //Name of the id where the chart will be drawn too
        this.chartid = chartid;
        //The values of the selected jurisdictions
        this.selectedjur = ["all"];
        //The class where the jurisdictions dropdown will be
        this.jurdropdownclass = jurdropdownclass;
        //The values of the products the user selected for the chart
        this.selectedproducts = ["all"];
        //The name of the HTML element
        this.productdropdownclass = productdropdownclass;
        //The HTML element for the time dropdown
        this.timedropdownclass = timedropdownclass;

        this.charttype = 'linechart';

        this.charttypeid = charttypeid;
        //The current time range they selected
        //Since time is NOT a multiselect, do not provide an array format like
        this.selectedtime = "12w";
        this.graphcardid = graphcardid;
    }
}

//https://www.w3resource.com/javascript-exercises/javascript-math-exercise-23.php
//Used to create a random id each time. Number of user's charts or some other metric is not good enough
function create_UUID() {
    var dt = new Date().getTime();
    var uuid = 'a99xxxxxyxxxyxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}


//Once the html body gets loaded, it will call this method which loads google charts
function loadgooglecharts(id) {
    google.charts.load('current', {'packages': ['corechart']});
    userId = id
    google.charts.setOnLoadCallback(init);
}


//Once the charts are ready, it calls this
async function init() {

    //Check to see if the user has any designs
    let designcheck = await getproductsapi(userId);
    if (designcheck == "NOTHING") {
        stopall = true;
    }

    if (!stopall) {
        //Gets the saved user data and handles no user data
        await getsaveduserdata(userId);

        loadALLhtmlchartcards(usercharts);


        //Load drop downs initiates the designmap var that is needed for getting a charts stats
        await loadALLdropdowns(usercharts);


        allowstats2update = true;
        //Updates the charts one by one and draws them
        await updateallstats();


        //Must be called after loaddropdowns
        await loadsumcardstats();
    } else {
        //TODO: handle no designs

        //Make things disappear :O
        document.getElementById("statscard").style.display = "none";
        document.getElementById("addchartcard").style.display = "none";

        var parentElement = document.getElementById('cardholder');

        var htmlcode = "<!--Start of a new \"card\" -->\n" +
            "            <div class=\"graph-card align-left nodesigns\">\n" +
            "<div class=\"page-title\"> <h1 id='nodesigntitle'>Analytics</h1>\n </div>\n <br>\n <div class=\"line-break\"></div>\n<br>\n"+
            "<div class='px24'>You haven't posted a design on Symbium Build yet</div> "+
            "</div>\n"

        var childElement = document.createElement('div');
        var appendChildElement = parentElement.appendChild(childElement);
        appendChildElement.innerHTML = htmlcode;

        //errormessage("You have no designs! Dan will handle this later");
    }

}


function errormessage(text) {
    alert(text);
    console.log(text);
}


//Needs to call load drop downs first because Jurmap needs to be filled in before calling gettopjursapi()
async function loadsumcardstats() {
    try {
        let topjursall;
        let topjurs30;
        let totalviewsall;
        let totalview30;
        [topjursall, topjurs30, totalviewsall, totalview30] = await Promise.all([gettopjursapi(userId, "all", 5, jurmap), gettopjursapi(userId, 30, 5, jurmap), gettotalviews(userId, "all"), gettotalviews(userId, 30)])

        let topjursallstring = "";
        let topjurs30string = "";

        //Format the results for HTML insertion
        topjursall.forEach(x => {
            topjursallstring = topjursallstring + x + "<br>";
        });
        topjurs30.forEach(x => {
            topjurs30string = topjurs30string + x + "<br>";
        });


        //Inserting into the html
        document.getElementById("top-jurs-all-time").innerHTML = "" + topjursallstring;
        document.getElementById("top-jurs-30-days").innerHTML = "" + topjurs30string;
        document.getElementById("total-views-all-time").innerHTML = "" + totalviewsall;
        document.getElementById("total-views-30-days").innerHTML = "" + totalview30;
    } catch (err) {
        console.log(err);
        errormessage("Could not load summary stats");
    }
}


//Call this when you want to update a single chart stats
async function updatesinglestats(chartobj, i) {
//Get the updated stats
    if (chartobj.selectedproducts.length > 0 && chartobj.selectedjur.length > 0 && chartobj.selectedtime !== "" && allowstats2update) {

        //Get the value of the dropdown and update the type of chart it is
        chartobj.charttype = document.getElementById(chartobj.charttypeid).value;

        await getsinglestatapi(userId, chartobj, designmap)
            .then(x => {
                //console.log(x); //DEBUG
                drawChart(x);
                //Saves the result in replace of the obj that was just changed
                usercharts[i] = x;
            }).catch(err => {
                console.log(err);
                errormessage("Could not update a chart's stats");
            })


        //console.log("chart info is done, drawing new chart") //DEBUG


    }

}

//Loops through all of the chart objects that was freshly loaded
async function updateallstats() {
    let i = 0;

    for (var x of usercharts) {
        await updatesinglestats(x, i);
        i++;
    }

}

function updatemebycharttypeid(id) {

    let object2beupdated;

    for (var obj of usercharts) {
        if (obj.charttypeid == id) {
            object2beupdated = obj;
        }
    }

    updatesinglestats(object2beupdated);

}

function loadALLhtmlchartcards(userchartarr) {
    for (var obj of userchartarr) {
        loadhtmlchartcards(obj);
    }
}

//Loads the HTML element to create a new "Card" for the chart and drop downs to go into
function loadhtmlchartcards(obj) {
    var parentElement = document.getElementById('cardholder');
    let htmlcode = 0;


    let areachart, linechart;
    if (obj.charttype == "linechart") {
        linechart = "selected";
        areachart = "";
    } else {
        areachart = "selected";
        linechart = "";
    }

    htmlcode = "<!--Start of a new \"card\" -->\n" +
        "            <div class=\"graph-card align-middle section-field\" id=\"" + obj.graphcardid + "\">\n" +
        "<div class='card-content'>\n" +
        "<div class='chart-type-dropdown'> " +
        "<div class='chart-name'>Chart Type:</div>\n" +
        "<select class=\"chart-type-select\" id=\"" + obj.charttypeid + "\">\n" +

        "<option value='linechart' " + linechart + "> Line Chart</option>" +
        "<option value='areachart' " + areachart + "> Area Chart</option>" +
        "</select>" +
        "</div>\n" +
        "<div class='chart-space'></div>\n" +
        "<div class='chart-x si-x si-icon-text-5x cursor-click'></div>\n" +
        "                <div class=\"google-chart\">\n" +
        "                    <div id=\"" + obj.chartid + "\"></div>\n" +
        "                </div>\n" +
        "                <div class=\"four-col leftdropdown\">\n" +
        "                    <div class=\"div-center\">Jurisdictions<br>\n" +
        "                        <span class=\"" + obj.jurdropdownclass + "\"></span>\n \n" +
        "                    </div>\n" +
        "                </div>\n" +
        "                <div class=\"four-col centerdropdown\">\n" +
        "                    <div class=\"div-center\">Product<br>\n" +
        "                        <span class=\"" + obj.productdropdownclass + "\"></span>\n  \n" +
        "                    </div>\n" +
        "                </div>\n" +
        "                <div class=\"four-col rightdropdown\">\n" +
        "                    <div class=\"div-center\">Time<br>\n" +
        "                        <span class=\"" + obj.timedropdownclass + "\"></span>\n  \n" +
        "                    </div>\n" +
        "                </div>\n" +
        "                <div class=\"w-100\"></div>\<n></n>" +
        "   </div>" +
        "</div>\n" +
        "            <!--End of a new \"card\" -->";

    var childElement = document.createElement('div');
    var appendChildElement = parentElement.appendChild(childElement);
    appendChildElement.innerHTML = htmlcode;

    var selects = document.querySelectorAll(`#${obj.graphcardid} select.chart-type-select`);
    for (var i = 0; i < selects.length; i++) {
        selects[i].onchange = () => updatemebycharttypeid(obj.charttypeid.toString())
    }

    var closeIcon = document.querySelectorAll(`#${obj.graphcardid} .chart-x`);
    for (var i = 0; i < selects.length; i++) {
        closeIcon[i].onclick = () => removehtmlbyid(obj.graphcardid.toString())
    }
    //console.log(obj.columns); //DEBUG
    //console.log(obj.xtitle);  //DEBUG

}

//Calls all of the dropdowns to load
async function loadALLdropdowns() {
    for (let i = 0; i < usercharts.length; i++) {

        //The first dropdown is special. Check the if statement in the function "loaddropdowns"
        if (i == 0) {
            await loaddropdowns(usercharts[i], true);
        } else {
            loaddropdowns(usercharts[i], false);
        }
    }
}

//https://www.cssscript.com/multi-select-autocomplete-selectpure/

//Adds the dropdown menu to the page
async function loaddropdowns(obj, firstloadup) {

    //The first load up of the dropdowns also gets the jurs available, designs a user has, and the times they can use
    if (firstloadup) {
        try {
            [jurisdictions, products, times] = await Promise.all([getjurisdictions(jurmap), getproducts(userId), gettimes(userId)])

            //console.log(products); //DEBUG

            if (products.length > 1) {
                for (let i = 1; i < products.length; i++) {
                    designmap.set(products[i].value, products[i].label);
                }
            }

        } catch (err) {
            console.log(err)
            errormessage("Promise failed when loading dropdowns");
        }
    }

    //!Attention! For some reason the class name must start with a letter and not a number or else the code in the try's will fail
    try {
        var tmp = new SelectPure("." + obj.jurdropdownclass, {
            options: jurisdictions,
            autocomplete: true,
            multiple: true,
            icon: "closepng",
            name: obj.jurdropdownclass,
            value: obj.selectedjur,
            onChange: (value, name) => {

                updatedropdownvalue(name, value, "jurisdiction");
            },
            //onChange: fns[obj.jurdropdownclass]
        });
    } catch (e) {
        console.log(e);
        errormessage("Could not load Jurisdiction Dropdown");
    }

    try {


        var tmp2 = new SelectPure("." + obj.productdropdownclass, {
            options: products,
            autocomplete: true,
            multiple: true,
            icon: "closepng",
            name: obj.productdropdownclass,
            value: obj.selectedproducts,
            onChange: (value, name) => {

                updatedropdownvalue(name, value, "product");
            },
            //onChange: fns[obj.jurdropdownclass]
        });
    } catch (e) {
        console.log(e);
        errormessage("Could not load Design Dropdown");
    }

    try {

        var tmp3 = new SelectPure("." + obj.timedropdownclass, {
            options: times,
            placeholder: false,
            name: obj.timedropdownclass,
            value: obj.selectedtime,
            onChange: (value, name) => {

                updatedropdownvalue(name, value, "time");
            },
            //onChange: fns[obj.jurdropdownclass]
        });
    } catch (e) {
        console.log(e);
        errormessage("Could not load Time Dropdown");
    }

}

//When ever there is a change to the dropdown menu (any of them) then this gets called
//Dropdownclass = the html span element name, value is the dropdown array value, and the type to know which array to save it in
async function updatedropdownvalue(dropdownclass, value, dropdowntype) {
    let object2beupdated = null;
    //Index will let the update single stats function what object to replace in the user's stored charts
    let index = 0;
    if (dropdowntype === "jurisdiction") {
        let i = 0;
        for (var obj of usercharts) {

            if (obj.jurdropdownclass === dropdownclass) {
                obj.selectedjur = value;
                object2beupdated = obj;
                index = i;
            }
            i++;
        }
    } else if (dropdowntype === "product") {
        let i = 0;
        for (var obj of usercharts) {
            if (obj.productdropdownclass === dropdownclass) {
                obj.selectedproducts = value;
                object2beupdated = obj;
                index = i;
            }
            i++;
        }
    } else if (dropdowntype === "time") {
        let i = 0;
        for (var obj of usercharts) {
            if (obj.timedropdownclass === dropdownclass) {
                obj.selectedtime = value;
                object2beupdated = obj;
                index = i;
            }
            i++;
        }
    }

    //Save the user data remotely after it is saved locally
    saveuserdata(userId);

    //Update the stats
    updatesinglestats(object2beupdated, index);
}

//TODO: Add network implementation later for possible build+ feature
async function gettimes(userid) {
    try {
        /*
        Last 4 weeks (by week)
        Last 3 months (by week)
        Last 6 months (by month)
        Last 12 months (by month)
        All time (by month)
         */
        let myOptions = [
            {
                label: "Last 4 Weeks",
                value: "4w",
            },
            {
                label: "Last 12 Weeks",
                value: "12w",
            },
            {
                label: "Last 6 Months",
                value: "6m",
            },
            {
                label: "Last 12 Months",
                value: "12m",
            }
        ];
        return myOptions;
    } catch (err) {
        console.log(err);
        errormessage("Could not get time");
    }
}

/*
Will add a new chart to the datastructure and call the functions to draw it
nochartsfoundreference is set to true if there are no saved user charts in the database-
Certian things shouldn't be called in this function because if you go up the stacktrace, it will be from the very first call of the init function */

function addnewchart(nochartsfoundreference) {


    var chart = new Chartobject([],
        [],
        'Views', 'Year', 'chart_div', create_UUID(), create_UUID(), create_UUID(), create_UUID(), create_UUID(), create_UUID());


    usercharts.push(chart);
    let len = usercharts.length - 1;

    if (nochartsfoundreference === true) {

    } else {
        allowstats2update = false;
        loadhtmlchartcards(chart);
        loaddropdowns(chart, false);
        allowstats2update = true;
        updatesinglestats(chart, len);

        saveuserdata();
    }


}


//TODO: implement saving of network charts
//Saves the user's data
function saveuserdata() {
    saveuserchartsapi(userId, usercharts, "update");
}

function removehtmlbyid(id) {
    let newusercharts = [];
    for (let i = 0; i < usercharts.length; i++) {
        if (usercharts[i].graphcardid == id) {

        } else {
            newusercharts.push(usercharts[i]);
        }
    }
    usercharts = newusercharts;
    document.getElementById(id).remove();
    saveuserdata();

}

//Returns all of the Jurs in the {Value: "X", Label: "Y"}, format
//The Value is a String but it really reperesents an int. The dropdown we use only lets values of the kind String
async function getproducts(userid) {
    try {
        let results;
        //console.log( await getproductsapi(userid, (x) => {myresult = x;}));
        let myOptions = await getproductsapi(userid);
        return myOptions;
    } catch (e) {
        console.log(e);
        errormessage("Could not get user's designs");
    }
}

//Returns all of the Jurs in the {Value: "X", Label: "Y"}, format
async function getjurisdictions() {
    let result = await getjurisdictionapi(jurmap);
    //First return var is the list of jurs
    let myOptions = result[0];
    //Second return is the map with a key:value of internalCityName:PrettyFrontFacingName
    jurmap = result[1];

    return myOptions;
}

//returns an array of saved user data

async function getsaveduserdata(userID) {

    let results = await getuserchartsapi(userID);
    let returnvar = [];
    if (results === "no charts") {
        addnewchart(true);
        saveuserchartsapi(userID, usercharts, "insert");
    } else if (results.length === 0) {
        //If the user removes all charts and then doesn't add a new one
        addnewchart(true);
        saveuserchartsapi(userID, usercharts, "update");
    } else if (results === "ERROR") {
        //Need to handle the error
    } else {
        //console.log("Userchart Results:"); //DEBUG
        //console.log(results); //DEBUG

        //If everything is fine and there is valid data
        usercharts = results;
    }

    /*
    var chart2 = new Chartobject(['Year', 'Alcatraz', 'Marina'],
        [['2013', 10, 20],
            ['2014', 11, 200],
            ['2015', 66, 10],
            ['2016', 10, 13]],
        'Views', 'Year', 'chart_div', "chart2", "jurisdiction2", "product2", "time2", "charttype2", "graphcardid2");
     */

}

//Draws all of the objects in usercharts
function drawall() {
    for (let i = 0; i < usercharts.length; i++) {
        //console.log(usercharts.length); //DEBUG
        drawChart(usercharts[i]);
    }
}


//Draws the chart
function drawChart(in_Chartobject) {
    //console.log("Printing chart"); //DEBUG

    var data = new google.visualization.DataTable();
    var columns = in_Chartobject.columns;

    //checks if data is all zeros
    var allZeros = !in_Chartobject.rows.filter(i=>!!Math.max(...i.slice(1))).length;

    //Assumption: First column is always a string and everything else is a number
    data.addColumn('string', columns[0]);
    for (var i = 1; i < columns.length; i++) {
        data.addColumn('number', columns[i]);
    }
    data.addRows(in_Chartobject.rows);

    function zeroAxis() {
        var yAxisRange = {
            max: null,
            min: null
        };
        for (var i = 1; i < data.getNumberOfColumns(); i++) {
            var range = data.getColumnRange(i);
            yAxisRange.max = yAxisRange.max || range.max;
            yAxisRange.max = Math.max(yAxisRange.max, range.max);
            yAxisRange.min = yAxisRange.min || range.min;
            yAxisRange.min = Math.min(yAxisRange.min, range.min);
        }
        return ((yAxisRange.max === 0) && (yAxisRange.min === 0));
    }
    
    var options = {
        title: in_Chartobject.title,
        width: '100%',
        height: 296,
        hAxis: {
            title: in_Chartobject.xtitle,
            titleTextStyle: {
                color: '#171717',
                italic: false,
                bold: true,
            },
        },
        vAxis: {
            baselineColor: '#C5C5C5',
            minValue: 0,
            color: '#6d6d6d',
            gridlines: {
                color: '#C5C5C5'
            },
            minorGridlines: {
                color: '#DDDDDD'
            }
        },
        animation: {
            startup: true,
            duration: 200,
            easing: 'inAndOut'
        },
        legend: {
            scrollArrows: {
                inactiveColor: "#CBCFF9",
                activeColor: "#5160EC"
            },
            pagingTextStyle: {
                color: "#6d6d6d"
            }
        },
        fontName: 'Inter',
        fontSize: 12,
        backgroundColor: '#FFFFFF',
        colors: ['#6d6d6d', '#B2E0EA', '#E3C981', '#EE787D', '#F5AEB1', '#3B469A', '#4BA693', '#93CABE', '#EEDFB3', '#D4B483', '#978FF6', '#7F64E8'],
        isStacked: true,
        lineWidth: 4,
        areaOpacity: .3,
        tooltip: {
            textStyle: {
                color: '#6d6d6d',
                fontName: 'Inter',
                fontSize: 16,
                bold: false,
                italic: false
            },
            isHtml: 'true'
        },
        chartArea: {
            left: '10%',
            top: 24,
            right: '20%',
            bottom: 48,
            width: '100%',
            height: '100%',
        }
    };
    if (zeroAxis())  {
        options.vAxis = {};
        options.vAxis.ticks = [0];
    }
    if (in_Chartobject.charttype == 'linechart') {
        var chart = new google.visualization.LineChart(document.getElementById(in_Chartobject.chartid));
    } else if (in_Chartobject.charttype == 'areachart') {
        options = {
            title: in_Chartobject.title,
            width: '100%',
            height: 296,
            hAxis: {
                title: in_Chartobject.xtitle,
                titleTextStyle: {
                    color: '#171717',
                    italic: false,
                    bold: true,
                },
            },
            vAxis: {
                baselineColor: '#C5C5C5',
                minValue: 0,
                color: '#6d6d6d',
                gridlines: {
                    color: '#C5C5C5'
                },
                minorGridlines: {
                    color: '#DDDDDD'
                }
            },
            animation: {
                startup: true,
                duration: 200,
                easing: 'inAndOut'
            },
            legend: {
                scrollArrows: {
                    inactiveColor: "#CBCFF9",
                    activeColor: "#5160EC"
                },
                pagingTextStyle: {
                    color: "#6d6d6d"
                }
            },
            fontName: 'Inter',
            fontSize: 12,
            backgroundColor: '#FFFFFF',
            colors: ['#6d6d6d', '#B2E0EA', '#E3C981', '#EE787D', '#F5AEB1', '#3B469A', '#4BA693', '#93CABE', '#EEDFB3', '#D4B483', '#978FF6', '#7F64E8'],
            lineWidth: 1,
            areaOpacity: 1,
            dataOpacity: 1,
            isStacked: true,
            tooltip: {
                textStyle: {
                    color: '#6d6d6d',
                    fontName: 'Inter',
                    fontSize: 16,
                    bold: false,
                    italic: false
                },
                isHtml: 'true'
            },
            chartArea: {
                left: '10%',
                top: 24,
                right: '20%',
                bottom: 48,
                width: '100%',
                height: '100%',
            }
        };
        if (zeroAxis())  {
            options.vAxis = {};
            options.vAxis.ticks = [0];
        }
        var chart = new google.visualization.AreaChart(document.getElementById(in_Chartobject.chartid));
    }

    //preprocess for all zeros
    if (allZeros) {
        chart.container.style.visibility = "hidden";
    }
    else {
        chart.container.style.visibility = "";
    }

    chart.draw(data, options);

    if (allZeros) {
        chart.container.style.visibility = "";
        var chartWidget = chart.container.querySelectorAll("[dir]")[0];
        chartWidget.innerHTML = "<div class='body-17' style='position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; display: -webkit-flex; align-items: center; justify-content: center; z-index: 9999; background-color: #FFFFFF;'>There are no results for the selected search parameters</div>";
    }
}


window.onresize = redrawcharts;

function redrawcharts() {
    drawall();
}

export {
  loadgooglecharts,
  addnewchart,
  errormessage
};
/*eslint-enable */
